import React from 'react';
import '../css/Footer.css';

const socialLinks = [
  {
    label: 'Facebook',
    href: 'https://www.facebook.com/aevoltenergy',
    icon: 'facebook',
  },
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/aevolt.energy/',
    icon: 'instagram',
  },
  {
    label: 'LinkedIn',
    href: 'https://www.linkedin.com/#',
    icon: 'linkedin',
  },
  {
    label: 'YouTube',
    href: 'https://www.youtube.com/#',
    icon: 'youtube',
  },
];

const contactUrl =
  'https://wa.me/94707246426?text=Hi%2C%20I%20would%20like%20to%20contact%20Aevolt%20Energy.';

function SocialIcon({ name }) {
  const iconProps = {
    className: 'social-icon',
    viewBox: '0 0 24 24',
    'aria-hidden': 'true',
    focusable: 'false',
  };

  if (name === 'facebook') {
    return (
      <svg {...iconProps}>
        <path d="M14 8.3V6.9c0-.7.2-1.1 1.1-1.1h1.7V3h-2.4C11.7 3 10 4.7 10 7v1.3H8v3h2V21h3.2v-9.7h2.6l.4-3H14Z" />
      </svg>
    );
  }

  if (name === 'instagram') {
    return (
      <svg {...iconProps}>
        <path d="M8 3h8a5 5 0 0 1 5 5v8a5 5 0 0 1-5 5H8a5 5 0 0 1-5-5V8a5 5 0 0 1 5-5Zm0 2.2A2.8 2.8 0 0 0 5.2 8v8A2.8 2.8 0 0 0 8 18.8h8a2.8 2.8 0 0 0 2.8-2.8V8A2.8 2.8 0 0 0 16 5.2H8Zm4 3.2a3.6 3.6 0 1 1 0 7.2 3.6 3.6 0 0 1 0-7.2Zm0 2.1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm4.1-2.8a.9.9 0 1 1 0 1.8.9.9 0 0 1 0-1.8Z" />
      </svg>
    );
  }

  if (name === 'linkedin') {
    return (
      <svg {...iconProps}>
        <path d="M6.8 8.7H3.7V20h3.1V8.7ZM5.3 4a1.8 1.8 0 1 0 0 3.6A1.8 1.8 0 0 0 5.3 4Zm14.9 9.8c0-3-1.6-5.1-4.3-5.1-1.5 0-2.5.8-3 1.6V8.7H9.8V20h3.1v-6.2c0-1.6.8-2.5 2.1-2.5 1.2 0 2 1 2 2.5V20h3.2v-6.2Z" />
      </svg>
    );
  }

  return (
    <svg {...iconProps}>
      <path d="M21.6 7.2s-.2-1.6-.9-2.3c-.9-.9-1.8-.9-2.3-1C15.2 3.7 12 3.7 12 3.7s-3.2 0-6.4.2c-.5.1-1.4.1-2.3 1-.7.7-.9 2.3-.9 2.3S2.2 9 2.2 10.8v1.7c0 1.8.2 3.6.2 3.6s.2 1.6.9 2.3c.9.9 2 .9 2.5 1 1.8.2 6.2.2 6.2.2s3.2 0 6.4-.2c.5-.1 1.4-.1 2.3-1 .7-.7.9-2.3.9-2.3s.2-1.8.2-3.6v-1.7c0-1.8-.2-3.6-.2-3.6ZM10.2 14.6V8.8l5.4 2.9-5.4 2.9Z" />
    </svg>
  );
}

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <nav className="footer-nav" aria-label="Footer navigation">
          <a href="#top">Aevolt Energy</a>
          <a href="#overview">Aevolt Everflow</a>
          <a href="#specs">Specs</a>
          <a href="#order">Order</a>
          <a href={contactUrl} target="_blank" rel="noopener noreferrer">
            Contact Us
          </a>
          <a href="#privacy">Privacy Policy</a>
        </nav>

        <nav className="footer-social" aria-label="Social media links">
          {socialLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
            >
              <SocialIcon name={link.icon} />
              <span>{link.label}</span>
            </a>
          ))}
        </nav>
      </div>
    </footer>
  );
}

export default Footer;
